"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiNewWindow16 = {
    paths: [
        {
            path: 'M5,0 C5.55228475,0 6,0.44771525 6,1 C6,1.55228475 5.55228475,2 5,2 L2,2 L2,12 L12,12 L12,9 C12,8.44771525 12.4477153,8 13,8 C13.5522847,8 14,8.44771525 14,9 L14,13 C14,13.5522847 13.5522847,14 13,14 L1,14 C0.44771525,14 6.76353751e-17,13.5522847 0,13 L0,1 C0,0.44771525 0.44771525,0 1,0 L5,0 Z M13.009222,0 C13.2813055,0 13.5277733,0.109742875 13.7068284,0.288462852 C13.8893106,0.47593315 14,0.722375058 14,0.990777969 L14,5.00922203 C14,5.55641359 13.5561352,6 13,6 C12.4477153,6 12,5.54902482 12,5.00922203 L11.9993376,3.41487599 L7.91487599,7.49933757 C7.52398585,7.89022771 6.89324696,7.89324696 6.5,7.5 C6.10947571,7.10947571 6.10435568,6.48143076 6.50066243,6.08512401 L10.585124,2.00066243 L8.99077797,2 C8.44358641,2 8,1.55613518 8,1 C8,0.44771525 8.45097518,0 8.99077797,0 L13.009222,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'New Window',
    width: 14,
    height: 14,
};
var muiNewWindow24 = {
    paths: [
        {
            path: 'M8,0 C8.55228475,-1.01453063e-16 9,0.44771525 9,1 C9,1.55228475 8.55228475,2 8,2 L2,2 L2,20 L20,20 L20,14 C20,13.4477153 20.4477153,13 21,13 C21.5522847,13 22,13.4477153 22,14 L22,21 C22,21.5522847 21.5522847,22 21,22 L1,22 C0.44771525,22 6.76353751e-17,21.5522847 0,21 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L8,0 Z M21,0 C21.2761424,0 21.5261424,0.111928813 21.7071068,0.292893219 C21.8880712,0.473857625 22,0.723857625 22,1 L22,1 L22,8 C22,8.55228475 21.5522847,9 21,9 C20.4477153,9 20,8.55228475 20,8 L20,8 L20,3.41421356 L10.7071068,12.7071068 C10.3165825,13.0976311 9.68341751,13.0976311 9.29289322,12.7071068 C8.90236893,12.3165825 8.90236893,11.6834175 9.29289322,11.2928932 L9.29289322,11.2928932 L18.5857864,2 L14,2 C13.4477153,2 13,1.55228475 13,1 C13,0.44771525 13.4477153,0 14,0 L14,0 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'New Window',
    width: 22,
    height: 22,
};
var muiNewWindow = {
    base: muiNewWindow16,
    smIcon: muiNewWindow16,
    lgIcon: muiNewWindow24,
};
exports.muiNewWindow = muiNewWindow;
//# sourceMappingURL=newWindow.js.map